
import { Table } from "flowbite-react";
import Viewdetails from "../component/order/viewdetails";
import { useSidebar } from "../context/SidebarOpenContext";
import Breadcrumb from "../hooks/Breadcrumb";
import { RiInboxArchiveFill } from "react-icons/ri";
import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
function ViewOrderDetails() {
    const navigate = useNavigate();
    const url = localStorage.getItem("url");
    const [searchParams] = useSearchParams();
    const { user } = useContext(AuthContext);
    const Order_id = searchParams.get("id");
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    const [suborder, setsuborder] = useState({});
    const [Marker, setMarker] = useState({});
    const breadcrumbItems = [
        {
            href: "/order",
            label: "Order",
            icon: (
                <RiInboxArchiveFill className="flex-shrink-0 w-5 h-5  " />

            ),
        },
        {
            label: "View Order",
        },

    ];
    useEffect(() => {
        // fetchmarker();
        fetchsuborder();
    }, []);
    useEffect(() => {
        if (!user) {
            navigate("/");
        } else {
            // fetchmarker();
            fetchsuborder();
        }
    }, [user, navigate]);

    // console.log(user);

    const fetchmarker = async () => {
        try {
            const response = await axios.get("master/size_variants");
            const markerData = response.data;
            setMarker(markerData);
        } catch (error) {
            console.error("Error fetching Marker data:", error);
        }
    };
    const fetchsuborder = async () => {
        try {
            const response = await axios.get(`order/suborders/${Order_id}`);
            const SubOrderData = response.data.suborders;
            setsuborder(SubOrderData);

        } catch (error) {
            console.error("Error fetching suborder data:", error);
        }
    };
    // console.log(suborder);

    const sizeVariantKeys =
        // Marker.length > 0 ? Marker
        // .filter((item) => suborder.sizevarientwithquantity[item.size_id] != undefined)
        // .map((item) => ({
        //     value: item.size_id,
        //     label: item.size
        // })) : [];
        Object.keys(
            suborder[0]?.size_variant_quantity || {}
        );

    return (
        <div className={` ${isSidebarOpen ? "p-4 sm:ml-64 bg-content-bg min-h-screen " : "p-4  bg-content-bg min-h-screen"}  `} >
            <div className="p-4 rounded-lg dark:border-gray-700 mt-14">
                <div className="p-4 rounded-lg shadow bg-white">
                    <div className="space-y-6">
                        <Breadcrumb items={breadcrumbItems} />
                        <Viewdetails orderid={Order_id} />

                        <div className="overflow-x-auto ">
                            <Table hoverable={true} className="w-full text-center">
                                <Table.Head className="border">
                                    <Table.HeadCell className="border text-center  min-w-[50px] max-w-[50px]">Colour</Table.HeadCell>
                                    {sizeVariantKeys.map((key) => (
                                        <Table.HeadCell key={key} className="border" >{key}</Table.HeadCell>
                                    ))}
                                    <Table.HeadCell className="border" >Total</Table.HeadCell>
                                </Table.Head>
                                <Table.Body className="divide-y">
                                    {suborder.length > 0 &&
                                        suborder.map((sub) => (
                                            <Table.Row key={sub.sub_order_id} className="bg-white cursor-pointer  hover:bg-content-bg hover:drop-shadow-xl hover:ring" onClick={() => navigate(`/view_sub_order_details?id=${Order_id}&sid=${sub.sub_order_id}`)}>

                                                {/* <Table.Cell className="border min-w-[80px] max-w-[100px] text-center align-top">
                                                    <div className="flex flex-col items-center justify-center">
                                                        <img
                                                            src={`${url}${sub.colour_image}`}
                                                            alt={sub.colour_name}
                                                            className="w-[50px] h-[40px] object-cover rounded-lg drop-shadow-md"
                                                        />
                                                        <span className="mt-1 text-sm break-words">{sub.colour_name}</span>
                                                    </div>
                                                </Table.Cell> */}

  <Table.Cell className="border align-top p-1 " >
                                        <div className="w-[60px] mx-auto ">
                                            <img
                                                src={`${url}${sub.colour_image}`}
                                                alt={sub.colour_name}
                                                className="w-[25px] h-[25px] object-cover rounded-lg drop-shadow-md mb-1 mx-auto"
                                            />
                                            <div className="text-[10px] text-jutify break-words whitespace-normal leading-tight ">
                                                {sub.colour_name}
                                            </div>
                                        </div>
                                    </Table.Cell>


                                                {sizeVariantKeys.map((key) => (
                                                    <Table.Cell key={key} className="border" >
                                                        {sub.size_variant_quantity[key] || ""}
                                                    </Table.Cell>
                                                ))}

                                                <Table.Cell className="border" >{sub.total_piece}</Table.Cell>
                                            </Table.Row>
                                        ))}
                                </Table.Body>
                            </Table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewOrderDetails;
